/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */
import { Grid, Typography } from '@mui/material';
import { ENVIRONMENT } from 'config';
import ROUTES from 'modules/common/constants/route';
import { BigAvatar, Wrapper } from './style';
import useSafeLocation from '../../hooks/use-safe-location';
//
const AuthWrapper = ({ children }) => {
  const { pathname } = useSafeLocation();
  //
  const isPtg = window.location.origin === ENVIRONMENT.APP_URL;
  const logo = isPtg ? ENVIRONMENT.APP_LOGO : ENVIRONMENT.AIRO_APP_LOGO;
  //
  return (
    <>
      {pathname === ROUTES.LOGIN && (
        <Wrapper>
          {logo && (
            <Grid container item xs={12} justifyContent="center" alignItems="center">
              <BigAvatar variant="square" alt={ENVIRONMENT.APP_NAME} src={logo} />
            </Grid>
          )}

          <Typography component="h3" variant="h4" align="center" gutterBottom>
            Admin Portal
          </Typography>
          <Typography component="h2" variant="body1" align="center" gutterBottom>
            Sign in to your account to continue
          </Typography>
          {children}
        </Wrapper>
      )}
      {pathname === ROUTES.FORGOT_PASSWORD && (
        <Wrapper>
          {logo && (
            <Grid container item xs={12} justifyContent="center" alignItems="center">
              <BigAvatar variant="square" alt={ENVIRONMENT.APP_NAME} src={logo} />
            </Grid>
          )}
          <Typography component="h1" variant="h4" align="center" gutterBottom>
            Forgot Password
          </Typography>
          <Typography component="h2" variant="body1" align="center">
            Enter your email to reset your password
          </Typography>
          {children}
        </Wrapper>
      )}
      {pathname === ROUTES.RESET_PASSWORD && (
        <Wrapper>
          {logo && (
            <Grid>
              <BigAvatar variant="square" alt={ENVIRONMENT.APP_NAME} src={logo} />
            </Grid>
          )}

          <Typography component="h1" variant="h4" align="center" gutterBottom>
            Reset Password
          </Typography>
          <Typography component="h2" variant="body1" align="center">
            Enter your new password to reset your password
          </Typography>
          {children}
        </Wrapper>
      )}
    </>
  );
};
//
export default AuthWrapper;
